var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexagonShapeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 80,
    viewBox: "0 0 114 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2553 14.598C18.0129 9.31351 23.4794 6 29.4402 6H84.5598C90.5206 6 95.9871 9.3135 98.7447 14.598L110.552 37.2243C111.459 38.9635 111.459 41.0365 110.552 42.7757L98.7447 65.402C95.9871 70.6865 90.5206 74 84.5598 74H29.4402C23.4794 74 18.0129 70.6865 15.2553 65.402L3.44844 42.7757C2.54088 41.0365 2.54088 38.9635 3.44844 37.2243L15.2553 14.598Z",
    fill: "url(#paint0_radial_8496_3898)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8496_3898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9598 12.7044C18.6974 7.36108 24.1959 4 30.1997 4H83.8003C89.8041 4 95.3026 7.36108 98.0402 12.7044L108.197 32.5283C109.957 35.9638 109.957 40.0362 108.197 43.4717L98.0402 63.2956C95.3026 68.6389 89.8041 72 83.8003 72H30.1997C24.1959 72 18.6974 68.6389 15.9598 63.2956L5.80333 43.4717C4.04322 40.0362 4.04322 35.9638 5.80333 32.5283L15.9598 12.7044Z",
    fill: "url(#paint1_linear_8496_3898)",
    fillOpacity: 0.65
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_8496_3898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8449 65.1195C18.2669 71.7986 25.14 76 32.6448 76H81.3553C88.86 76 95.7331 71.7987 99.1551 65.1195L106.328 51.1195C109.261 45.3937 109.261 38.6063 106.328 32.8805L99.1551 18.8805C95.7331 12.2014 88.86 8 81.3552 8H32.6447C25.14 8 18.2669 12.2013 14.8449 18.8805L7.67222 32.8805C4.73871 38.6063 4.7387 45.3937 7.67222 51.1195L14.8449 65.1195Z",
    fill: "url(#paint2_linear_8496_3898)",
    fillOpacity: 0.45
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8496_3898",
    x: 0.483398,
    y: 0,
    width: 113.033,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_8496_3898"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_8496_3898",
    x: 1.47168,
    y: 4,
    width: 111.057,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_8496_3898"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8496_3898",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.8724 41.3983) rotate(90) scale(39.1017 74.1577)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#F4FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCF0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8496_3898",
    x1: 57,
    y1: 41.2162,
    x2: 56.9108,
    y2: 71.9997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#C0DCE9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0DCE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8496_3898",
    x1: 57,
    y1: 38.7838,
    x2: 56.9108,
    y2: 8.00026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.685,
    stopColor: "#D5EEF9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5EEF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonShapeIcon);
export default __webpack_public_path__ + "static/media/hexagon-shape-icon.50dd339fcc2ca1c0d4d84436f0b10584.svg";
export { ForwardRef as ReactComponent };